import errorMap from "@gap/backend/util/validations/validation-error-map"
import { z } from "zod"

export const gapErrorTypes = ['unauthorised', 'notFound', 'support', 'triedUpdatingStaleRecord', 'forbidden', 'generic', 'locked', 'conflict', 'unprocessable', 'userIsDeactivated', 'chatAllowanceReached'] as const
export type GapErrorType = typeof gapErrorTypes[number]

export const gapErrorShapeSchema = z.object({
   gapErrorType: z.enum(gapErrorTypes, { errorMap }),
})

export type GapErrorShape = z.infer<typeof gapErrorShapeSchema>
